import IForeignItem from "../responses/IForeignItem";
import Item from "./Item";
import SignatureItem from "./SignatureItem";
import SupplierItem from "./SupplierItem";

export default class SupplierSignatureItem extends SignatureItem {
  constructor(
    public item: Item,
    public unitCode: string,
    public quantity: number,
    lot: string | undefined = undefined,
    public bestBefore: string | undefined = undefined,
    public expiry: string | undefined = undefined,
    public isInbound: boolean = false,
    public trackStock: boolean = true,
    public supplierItem: SupplierItem | undefined = undefined,
    public foreignItem: IForeignItem | undefined = undefined,
  ) {
    super(item, unitCode, quantity, lot, bestBefore, expiry, isInbound, trackStock);
  }
}